import { render, staticRenderFns } from "./SingleItemForModal.vue?vue&type=template&id=5f97dd4d&"
import script from "./SingleItemForModal.vue?vue&type=script&lang=js&"
export * from "./SingleItemForModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports